import common from '@/store/common/mutations';
import * as types from './mutation-types';
import { SEARCH_PARAMS, PAGING_INFO, SELECTED_ROW } from './state';

export default {
	...common,
	[types.STATE_INIT]: state => {
		state.isMmcAdmin = false;
		state.searchParams = SEARCH_PARAMS();
		state.pagingInfo = PAGING_INFO();
		state.excelDownLoadList = [];
		state.resultList = [];
		state.selectedRow = SELECTED_ROW();
	},
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.PAGING_INFO]: (state, { key, value }) => {
		state.pagingInfo[key] = value;
	},
	[types.SELECTED_ROW]: (state, { key, value }) => {
		state.selectedRow[key] = value;
	},
	[types.UPDATE_ROWS]: (state, newRow) => {
		const currows = [...state.torqRgstManagements];
		currows.unshift(newRow);
		state.torqRgstManagements = currows;
	}
};
